import React, { useEffect, memo } from 'react';

import { EquityListStore } from '../store';
import { Modal, Alert } from 'antd';
import { observer } from 'mobx-react-lite';
import { tryRefresh } from '@/utils';

export const ActionDelete: React.FC<{
    defaultStore: EquityListStore;
}> = observer(({ defaultStore }) => {
    const { mutatingData } = defaultStore;
    if (mutatingData === null) {
        return null;
    }
    const visible = defaultStore.actionType === 'delete';
    return (
        <Modal
            visible={visible}
            title={'删除权益'}
            onCancel={() => {
                defaultStore.resetAction();
            }}
            onOk={async () => {
                const ok = await defaultStore.delete();
                if (ok) {
                    defaultStore.resetAction();
                    tryRefresh(['equity']);
                }
            }}
        >
            <p>是否删除权益【{mutatingData.equity_name}】？</p>
            <Alert type="error" message="删除成功之后，该操作无法恢复。" />
        </Modal>
    );
});
